import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container } from 'components';
import { JobNimbusContainer } from 'components';
import { hasPermission } from 'actions';
import * as Permissions from 'permissions';
import { browserHistory } from 'react-router';

class IntegrationsContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    if(!this.props.hasPermission(Permissions.INTEGRATIONS)) {
      browserHistory.goBack();
    }
  }

  render() {
    return (
      <Container title='Settings/Integrations'>
        <div className='integrations-container'>
        {this.props.hasPermission(Permissions.INTEGRATIONS_JOBNIMBUS) ? (
          <JobNimbusContainer />
        ) : null}
        </div>
      </Container>
    )
  }
}

export default connect(null, { hasPermission })(IntegrationsContainer);



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/integrations-container.js